import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import WhyRbl from "@/components/site/WhyRbl";
import ProductGroups from "@/components/site/ProductGroups";
import PrivateLabel from "@/components/site/PrivateLabel";
import Global from "@/components/site/Global";
import HowWeWork from "@/components/site/HowWeWork";
import Certifications from "@/components/site/Certifications";
import QuoteForm from "@/components/site/QuoteForm";
import Contact from "@/components/site/Contact";

export default function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <WhyRbl />
      <ProductGroups />
      <PrivateLabel />
      <Global />
      <HowWeWork />
      <Certifications />
      <QuoteForm />
      <Contact />
    </>
  );
}
